import { BaseComponent } from './../../shared/components/base.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { InfiniteScrollDirective } from 'src/app/shared/directives/infinite-scroll.directive';
import { envSettings } from 'src/common/constant';
import { AuthenticationService } from 'src/core/http/authentication.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent extends BaseComponent implements OnInit {
  // @ViewChild(InfiniteScrollDirective, {static: true}) infiniteScrollElem;
  public enviOptions = envSettings;

  firstName = '';
  lastName = '';

  constructor(
    protected authenticationService: AuthenticationService,
  ) {
    super(authenticationService);
    this.enviOptions.headerSectionTitle = '';
    this.enviOptions.headerSectionIcon = null;
  }

  ngOnInit(): void {
    // this.infiniteScrollElem.scrollEnding$
    //  .pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
    //   console.log('infiniteScroll tock');
    //   console.log(data);
    // });
    const userInfo = this.authenticationService.userInfo;
    if (userInfo) {
      this.firstName = userInfo.AuthResult.FirstName;
      this.lastName = userInfo.AuthResult.LastName;
    }
  }


    // // Callback function by directive
    // // How to access the correct `this` inside a callback?
    // // https://stackoverflow.com/questions/51711121/callback-function-by-directive
    // scrollEnding = (event): void => {
    //   console.log('FAKE load next page');
    // }

}
